



















import { Component, Vue, Prop } from 'vue-property-decorator';
import { JobsStore } from '@/models/jobs/jobs.vuex';
import { Job } from '@/models/jobs/job';
import { vxm } from '@/store.vuex';

@Component({
  name: 'Broadcast',
  components: {},
})
export default class Broadcast extends Vue {
  get message(): string {
    return vxm.jobs.AdminMessage;
  }

  mounted() {
    vxm.jobs.loadLatLong();
  }
}
